import 'jqueryLazy';
import HeaderBasket from './header-basket';
import helper from './helper';
import modal from './modal';
import notification from './notification';

class Product {
    constructor() {
        this.lazy();

        let _this = this;

        $(document).on('submit', '.form-add-to-basket', function (e) {
            e.preventDefault();
            return _this.addToBasket($(this));
        });

        $(document).on('click', '.product-fastbuy', function (e) {
            _this.fastBuy(e, $(this).closest('form'));
        });

        let itemsSort = $('#items-sort');
        let itemsCount = $('#items-count');

        itemsSort.on('change', function () {
            changeSorting(itemsSort.val(), itemsCount.val());
        });
        itemsCount.on('change', function () {
            changeSorting(itemsSort.val(), itemsCount.val());
        });
    }

    lazy() {
        $('.shop-product-list__pic').Lazy({
            afterLoad: function (element) {
                element.css('display', 'block');
            },
        });
    }

    collectOrderDataForModal($el) {
        let result = [];
        $el.find('input, select').each((index, el) => {
            result.push({
                name: $(el).attr('name'),
                value: $(el).val(),
            });
        });
        return result;
    }

    fastBuy(e, $el) {
        let buttonData = $(e.target).data().transferToModal;
        let dataToTransferToModal = {};
        try {
            let data;
            eval('data = ' + buttonData);
            dataToTransferToModal = data;
        } catch (e) {}
        let hiddenFields = this.collectOrderDataForModal($el);
        const modalData = $.extend(dataToTransferToModal, {
            template: 'modal-fastbuy',
            hiddenFields,
        });
        modal(modalData);
    }

    addToBasket($el) {
        let $productParent = $el.closest('.js-product-data');
        let data = $el.serialize();

        $el.find('[type=submit]').prop('disabled', true);

        $.post($el.attr('action'), data, null, 'json')
            .done((data) => {
                if (data.result && data.result === 'fail')
                    return notification({
                        status: 'error',
                        message: data.message,
                    });

                HeaderBasket.update(data.basketCount, data.basketTotal);

                modal({
                    template: 'modal-basket-result',
                    title: $el.data('title'),
                    desc: $el.data('desc'),
                    image: $el.data('img'),
                    price: $el.data('price'),
                    oldPrice: $el.data('oldPrice'),
                    count: data.basketCount,
                    word: helper.declension(data.basketCount, [
                        'товар',
                        'товара',
                        'товаров',
                    ]),
                    summ: data.basketTotal,
                });
            })
            .always(() => {
                setTimeout(() => {
                    $el.find('[type=submit]').prop('disabled', false);
                }, 500);
            });
    }
}

function changeSorting(srt, npp) {
    $.ajax({
        url: '/json/setCookie.json',
        type: 'POST',
        dataType: 'json',
        data: {
            srt: srt,
            npp: npp,
        },
        success: function (data) {
            window.location.href = removeURLParameter(
                window.location.href,
                'page'
            );
        },
    });
}

function removeURLParameter(url, parameter) {
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);
        for (var i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

export default new Product();
